import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./AskAiAbout.module.css";
import AIPopupContext from "../../contexts/AIPopupContext";

// Each prompt is sent as the question, so a prompt is sent in the language it
// is shown in and the assistant answers in that language.
const EXAMPLE_QUESTION_KEYS = [
	"ai:askAbout.prompts.course",
	"ai:askAbout.prompts.summary",
	"ai:askAbout.prompts.examples",
	"ai:askAbout.prompts.quiz",
	"ai:askAbout.prompts.resources",
];

function AskAiAbout() {
	const { t } = useTranslation();
	const { setPrefilledAnswer } = useContext(AIPopupContext);

	return (
		<div className={style.askAbout}>
			<h3>{t("ai:askAbout.heading")}</h3>
			<ul>
				{EXAMPLE_QUESTION_KEYS.map((key) => (
					<li key={key} onClick={() => setPrefilledAnswer(t(key))}>
						{t(key)}
					</li>
				))}
			</ul>
		</div>
	);
}

export default AskAiAbout;
